import { Component, OnInit } from '@angular/core';
import { parse } from 'querystring';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  user = this.getUser();
  isAdmin: boolean = this.getIsAdmin();

  ngOnInit() {  }

  private getUser() {
    return sessionStorage.getItem("loginData") != null ? JSON.parse(sessionStorage.getItem("loginData")).userResponse : null;
  }

  private getIsAdmin() {
    if (this.getUser() == null)
      return false;
    let resultado = (this.getUser().profile != null) && (this.getUser().profile.find(x => x === "1") != null);
    return resultado;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
